export default __webpack_public_path__ + "static/media/passenger_second.48a05584.png";